export const generativeAiAgentsTools = "/generative_ai/agents/tools";
